// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LinksWrapper_wrapper__4gAK_","column":"LinksWrapper_column__bgjem"};